import { SelectionType } from "@dextall/panel-hooks-editor-2d";
import { noop } from "../../../shared";
import { ImperialAndMetricDimensionEditor } from "../../editor-inputs/imperialAndMetricDimensionEditor";
import { PanelEditorScope } from "../../panels/panel-editor-scope";
import { Parameters } from "./parameters";
import { ParametersLabel } from "./parametersLabel";
import { usePanelSelectedComponent } from "./usePanelSelectedComponentHook";
import { WindowDesignParameters } from "./window-design-parameters/windowDesignParameters";

type Props = {
    panelEditorScope: PanelEditorScope;
};

export const PanelWindowPropertiesDockingPanelContent = ({ panelEditorScope }: Props) => {
    const { panel, selection } = usePanelSelectedComponent(panelEditorScope);

    if (!(panel && selection && selection.type === SelectionType.Window)) {
        return null;
    }

    const panelWindow = panel.windows[selection.index];

    return (
        <div className="fullheight">
            <Parameters>
                <WindowDesignParameters panel={panel} selection={selection} />
                <ParametersLabel label="Opening dimensions:" />

                <ImperialAndMetricDimensionEditor
                    value={panelWindow.openingWidth}
                    onChange={noop}
                    title="Width:"
                    disabled
                />

                <ImperialAndMetricDimensionEditor
                    value={panelWindow.openingHeight}
                    onChange={noop}
                    title="Height:"
                    disabled
                />
                <ParametersLabel label="Frame dimensions:" />

                <ImperialAndMetricDimensionEditor
                    value={panelWindow.frameWidth}
                    onChange={noop}
                    title="Width:"
                    disabled
                />

                <ImperialAndMetricDimensionEditor
                    value={panelWindow.frameHeight}
                    onChange={noop}
                    title="Height:"
                    disabled
                />
            </Parameters>
        </div>
    );
};
